/**
 * Un mensaje del chat con su formato, como en Claude (CH-1, 26-sep): negritas, cursivas, títulos,
 * listas, citas, tablas y código. La lectura del Markdown vive en logica.ts; aquí solo se pinta,
 * con elementos de React y sin HTML crudo.
 */
import type { ReactNode } from "react";
import { bloquesDeMarkdown } from "../logica";
import type { BloqueMd, Trozo } from "../logica";

function trozos(ts: Trozo[]): ReactNode[] {
  return ts.map((x, i) =>
    x.t === "texto" ? x.v
    : x.t === "negrita" ? <strong key={i}>{trozos(x.hijos)}</strong>
    : x.t === "cursiva" ? <em key={i}>{trozos(x.hijos)}</em>
    : x.t === "codigo" ? <code key={i}>{x.v}</code>
    : <a key={i} href={x.href} target="_blank" rel="noreferrer noopener">{x.v}</a>);
}

function bloque(b: BloqueMd, i: number): ReactNode {
  switch (b.t) {
    case "p": return <p key={i}>{trozos(b.trozos)}</p>;
    case "h": {
      const Etiqueta = (`h${Math.min(6, b.nivel + 2)}`) as "h3" | "h4" | "h5" | "h6";
      return <Etiqueta key={i}>{trozos(b.trozos)}</Etiqueta>;
    }
    case "lista": {
      const Lista = b.ordenada ? "ol" : "ul";
      return <Lista key={i}>{b.items.map((it, j) => <li key={j}>{trozos(it)}</li>)}</Lista>;
    }
    case "cita": return <blockquote key={i}>{trozos(b.trozos)}</blockquote>;
    case "tabla": return (
      <div className="tabla-chat" key={i}>
        <table>
          <thead><tr>{b.cabecera.map((c, j) => <th key={j}>{trozos(c)}</th>)}</tr></thead>
          <tbody>{b.filas.map((f, j) => <tr key={j}>{f.map((c, k) => <td key={k}>{trozos(c)}</td>)}</tr>)}</tbody>
        </table>
      </div>
    );
    case "codigo": return <pre key={i}><code>{b.v}</code></pre>;
    case "raya": return <hr key={i} />;
  }
}

export default function TextoChat({ texto, className = "", style }: { texto: string; className?: string; style?: React.CSSProperties }) {
  return <div className={"texto-chat md " + className} style={style}>{bloquesDeMarkdown(texto).map(bloque)}</div>;
}
